// extracted by mini-css-extract-plugin
module.exports = {"gallery":"MemoryGallery_gallery__ZI3g0"};